import Keycloak from "keycloak-js";

function useKeycloakInstance() {
  const keycloakConfig = {
    url: process.env.REACT_APP_URL,
    realm: process.env.REACT_APP_REALM,
    clientId: process.env.REACT_APP_CLIENTID,
  };

  const keycloak = new Keycloak(keycloakConfig);

  return [keycloak];
}

export default useKeycloakInstance;
